<template>
    <div class="order-complete">
        <div class="columns is-multiline">
            <div class="column is-12-mobile is-12-tablet is-6 is-6-desktop cp-top-column-order-complete">
                <nav class="panel" v-if="cpOrderQuoteResponse">
                    <p class="panel-heading">
                        Order details
                    </p>
                    <div class="panel-block">
                        <table class="table is-fullwidth">
                            <tbody>
                            <tr>
                                <td colspan="2" style="padding-right: 0">
                                    <table class="table is-fullwidth" style="margin: 0">
                                        <tbody>
                                            <tr>
                                                <th>Product</th>
                                                <th>Quantity</th>
                                            </tr>

                                            <tr v-for="(product, index) of cartProducts" v-bind:key="index">
                                                <td width="80%" style="word-break: break-all" v-if="product.type !== 'stock'">
                                                    {{product.cpProductInfo.name}}
                                                    <br>
                                                    <small v-for="option in getProductOptions(index)" style="font-size: 13px;" v-bind:key="option"> – {{option}}<br></small>

                                                    <small v-for="(file, type) in product.cp_files[product.file_storage]" v-bind:key="type">
                                                        <div
                                                            v-if="product.file_storage === 'link'"
                                                            style="font-size: 13px; margin-top: 4px;"
                                                        >
                                                            <read-more
                                                                    more-str="read more"
                                                                    :text="'– File ' + type + ': ' + file"
                                                                    style="display: inline-flex;"
                                                                    :max-chars="50">
                                                            </read-more>
                                                        </div>
                                                        <small v-else style="font-size: 13px;">– File {{type}}: {{file.name}}<br></small>
                                                    </small>
                                                </td>
                                                <td>{{product.quantity}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>

                            <tr v-if="!quoteError && cpOrderQuoteResponse.subtotals">
                                <td colspan="2" style="padding-top: 18px;" class="word-break-all">
                                    <span style="font-weight: bold">Delivery address</span>
                                    <br>
                                    <span v-if="orderData.shipping_address.company">
                                        {{orderData.shipping_address.company}}
                                        <br>
                                    </span>
                                    {{orderData.shipping_address.firstname}}
                                    {{orderData.shipping_address.lastname}}<br>
                                    {{orderData.shipping_address.street1}}
                                    <span v-if="orderData.shipping_address.street2">{{orderData.shipping_address.street2}}</span><br>
                                    {{orderData.shipping_address.zip}}, {{orderData.shipping_address.city}}<br>
                                    {{$store.getters['cpOrder/countryName']}}
                                    <span v-if="orderData.stateIsRequired">, {{$store.getters['cpOrder/stateName']}}</span><br>
                                    {{orderData.shipping_address.email}}<br>
                                    {{orderData.shipping_address.phone}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </nav>
            </div>

            <div class="column is-12-mobile is-12-tablet is-6 is-6-desktop cp-top-column-order-complete">
                <nav class="panel" v-if="cpOrderQuoteResponse">
                    <p class="panel-heading">
                        Order summary
                    </p>
                    <div class="panel-block">
                        <table class="table is-fullwidth">
                            <tbody>
                            <tr>
                                <td style="font-weight: bold; padding-bottom: 14px;">
                                    <span class="required-field">Order reference</span>
                                    <br>
                                    <small style="font-weight: normal; font-size: 13px;">Your unique reference for the
                                        order
                                    </small>
                                </td>
                                <td class="has-text-right cp-order-reference">
                                    <template>
                                        <section class="has-text-left">
                                            <b-field
                                                    custom-class="required-field"
                                                    :type="{'is-danger': errors.has('shipping_method_form.order reference')}"
                                                    :message="errors.first('shipping_method_form.order reference')">
                                                <b-input v-model="orderData.order_reference"
                                                         v-validate="'required|reference'"
                                                         data-vv-scope="shipping_method_form"
                                                         @keydown.native="onKeyDownCharsFilterNumbersAndLetters($event, ['Backspace', '-', '_'])"
                                                         name="order reference"></b-input>
                                            </b-field>
                                        </section>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">
                                  <span class="required-field">Order mode</span>

                                </td>
                                <td class="has-text-right">
                                    <template v-if="cartProducts.length > 0">
                                        <section class="has-text-left">
                                            <b-field
                                                    style="display: block; margin-top: 4px;"
                                                    :type="{'is-danger': errors.has('shipping_method_form.order mode')}"
                                                    :message="errors.first('shipping_method_form.order mode')">
                                                <b-radio v-model="orderData.mode"
                                                         v-validate="'required'"
                                                         data-vv-scope="shipping_method_form"
                                                         name="order mode"
                                                         native-value="live">
                                                    Live
                                                </b-radio>
                                                <br>
                                                <b-radio v-model="orderData.mode"
                                                         v-validate="'required'"
                                                         data-vv-scope="shipping_method_form"
                                                         name="order mode"
                                                         native-value="sandbox">
                                                    Sandbox
                                                </b-radio>
                                                <br>
                                                <b-radio v-model="orderData.mode"
                                                         v-if="supportFeature('production_test_mode')"
                                                         v-validate="'required'"
                                                         data-vv-scope="shipping_method_form"
                                                         name="order mode"
                                                         native-value="production_test">
                                                    Production test
                                                </b-radio>
                                            </b-field>
                                        </section>
                                    </template>
                                </td>
                            </tr>

                            <tr v-if="!quoteError && cpOrderQuoteResponse.subtotals">
                                <td style="font-weight: bold">Product price</td>
                                <td class="has-text-right">
                                    {{cpOrderQuoteResponse.subtotals.items | currency(orderData.currency)}}
                                </td>
                            </tr>
                            <tr v-if="!quoteError && cpOrderQuoteResponse.subtotals && parseFloat(cpOrderQuoteResponse.subtotals.fee) > 0.0000">
                                <td style="font-weight: bold">Fee</td>
                                <td class="has-text-right">
                                    {{cpOrderQuoteResponse.subtotals.fee | currency(orderData.currency)}}
                                </td>
                            </tr>
                            <tr v-if="!quoteError && cpOrderQuoteResponse.vat">
                                <td style="font-weight: bold">VAT</td>
                                <td class="has-text-right">
                                    {{this.orderData.vat | currency(orderData.currency)}}
                                </td>
                            </tr>
                            <tr v-for="(cpOrderShipping, index) of orderData.cpOrderShipping" v-bind:key="index">
                                <td style="font-weight: bold; width: 40%">
                                  <span class="required-field">Shipping method</span> <br>
                                    <ul>
                                        <li style="font-weight: normal; font-size: 13px;"
                                            v-for="productName of cpOrderShipping.products"
                                            v-bind:key="productName">– {{productName}} <br></li>
                                    </ul>
                                </td>
                                <td class="has-text-right">
                                    <span v-if="quoteError" style="color: #ff3860;">
                                        {{quoteError}}
                                    </span>
                                    <section class="has-text-left" id="shipping-methods">
                                        <small class="help is-danger" v-if="cpOrderShipping.quotes.length == 0">
                                            The shipping is not possible. Please, contact support.
                                        </small>
                                        <b-field
                                                style="display: block; margin-top: 4px;"
                                                :type="{'is-danger': errors.has('shipping_method_form.shipping method' + index)}"
                                                :message="errors.first('shipping_method_form.shipping method' + index)">
                                            <p v-for="quoteData in cpOrderShipping.quotes" v-bind:key="quoteData.quote"
                                               class="has-text-left">
                                                <b-radio
                                                        v-model="orderData.quotes[index]"
                                                        v-validate="'required'"
                                                        :input="selectShippingMethod()"
                                                        data-vv-as="shipping method"
                                                        data-vv-scope="shipping_method_form"
                                                        :name="'shipping method' + index"
                                                        :native-value="quoteData.quote">

                                                    <div class="columns">
                                                        <div class="column is-8" style="padding-top: 0; margin-bottom: 13px;">
                                                            <span class="title is-6">{{quoteData.meta.service}}</span><br>
                                                            <span class="title is-7">{{quoteData.meta.shipping_option}}</span>
                                                        </div>
                                                        <div class="column is-4 has-text-right" style="padding-top: 0">
                                                            <span v-if="quoteData.meta.price === '0.00 EUR'">
                                                                Free
                                                            </span>

                                                            <span v-else>
                                                                {{quoteData.meta.price | currency(quoteData.meta.currency)}}
                                                            </span>

                                                            <div style="font-size: 12px;">VAT: {{ quoteData.meta.vat | currency(quoteData.meta.currency) }}</div>
                                                        </div>
                                                    </div>
                                                </b-radio>
                                            </p>
                                        </b-field>
                                    </section>
                                </td>
                            </tr>
                            <tr v-if="Object.keys(orderData.quotes).length > 0">
                                <td style="border: none">
                                    <span style="font-weight: bold">Total price</span>

                                </td>
                                <td class="has-text-right"
                                    style="font-weight: bold; color: #055DC2; border: none">
                                    {{this.orderData.total_price | currency(orderData.currency)}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import Cloudprinter from '@/services/CloudprinterService'
import EventBus from '@/event-bus'
import UserMixin from '@/mixins/UserMixin'
import ProductMixin from '@/mixins/ProductMixin'
import InputFieldMixin from '@/mixins/InputFieldMixin'
import { Validator } from 'vee-validate'
import referenceValidator from '@/validators/reference'

export default {
  name: 'OrderComplete',
  mixins: [UserMixin, ProductMixin, InputFieldMixin],

  data () {
    return {
      orderData: {},
      cartProducts: [],
      cpOrderQuotes: [],
      cpOrderQuoteResponse: {},
      quoteError: null
    }
  },

  created () {
    Validator.extend('reference', referenceValidator, {
      computesRequired: true
    })

    this.orderData = this.$store.getters['cpOrder/allData']
    this.cartProducts = this.$store.getters['cart/products']
  },

  mounted () {
    // Remove the event listener if exists. To avoid the duplication the same events.
    EventBus.$off('REQUEST_ORDER_QUOTE');

    // Create event listener.
    EventBus.$on('REQUEST_ORDER_QUOTE', () => {
      this.requestOrderQuote()
    })
  },

  methods: {
    requestOrderQuote: function () {
      let orderItem = this.$store.getters['cart/itemsForPriceCheck']
      this.$store.dispatch('loader/show')

      let orderQuoteData = {
        'country': this.orderData.shipping_address.country,
        'items': orderItem
      }

      if (this.orderData.stateIsRequired || this.$store.getters['cart/state']) {
        orderQuoteData.state = this.orderData.shipping_address.state || this.$store.getters['cart/state']
      }

      Cloudprinter.orderQuote(orderQuoteData).then((response) => {
        this.orderData.cpOrderShipping = []
        this.orderData.quote = null
        this.quoteError = null
        this.cpOrderQuoteResponse = response.data
        this.orderData.product_price = response.data.price + response.data.currency
        this.orderData.currency = response.data.currency

        for (let [index, shipment] of response.data.shipments.entries()) {
          let shippingQuotes = []
          let products = []
          for (let shipmentItem of shipment.items) {
            products.push(this.cartProducts[Number(shipmentItem.reference) - 1].cpProductInfo.name)
          }

          for (let quoteData of shipment.quotes) {
            let price = parseFloat(quoteData.price)

            shippingQuotes.push({
              quote: quoteData.quote,
              meta: {
                service: quoteData.service,
                shipping_option: quoteData.shipping_option,
                price: price.toFixed(2),
                currency: quoteData.currency,
                vat: quoteData.vat
              }
            })
          }

          this.orderData.cpOrderShipping.push({
            quotes: shippingQuotes,
            products: products,
            items: shipment.items
          })
        }
      }).catch((error) => {
        this.quoteError = error.response.data.error.info
      }).finally(() => {
        this.$store.dispatch('loader/hide')
      })
    },

    getTotalPrice: function () {
      if (!this.cpOrderQuoteResponse) {
        return 0
      }

      let totalPrice = parseFloat(this.cpOrderQuoteResponse.price)
      let selectedQuotes = Object.values(this.orderData.quotes)

      totalPrice += parseFloat(this.cpOrderQuoteResponse.vat)

      if (selectedQuotes.length === 0) {
        return totalPrice
      }

      if (this.orderData.quotes && this.cpOrderQuoteResponse && Array.isArray(this.cpOrderQuoteResponse.shipments)) {
        for (let shipment of this.cpOrderQuoteResponse.shipments) {
          for (let quoteData of shipment.quotes) {
            if (selectedQuotes.indexOf(quoteData.quote) !== -1) {
              totalPrice += parseFloat(quoteData.price)
              totalPrice += parseFloat(quoteData.vat)
            }
          }
        }
      }

      return totalPrice
    },

    getTotalVAT: function () {
      if (!this.cpOrderQuoteResponse) {
        return 0
      }
      let totalVAT = parseFloat(this.cpOrderQuoteResponse.vat)
      let selectedQuotes = Object.values(this.orderData.quotes)

      if (selectedQuotes.length === 0) {
        return totalVAT
      }

      if (this.orderData.quotes && this.cpOrderQuoteResponse && Array.isArray(this.cpOrderQuoteResponse.shipments)) {
        for (let shipment of this.cpOrderQuoteResponse.shipments) {
          for (let quoteData of shipment.quotes) {
            if (selectedQuotes.indexOf(quoteData.quote) !== -1) {
              totalVAT += parseFloat(quoteData.vat)
            }
          }
        }
      }

      return totalVAT
    },

    selectShippingMethod: function () {
      this.orderData.total_price = this.getTotalPrice()
      this.orderData.vat = this.getTotalVAT()
    }
  }
}
</script>
